 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {useMutation,} from 'react-relay'

import useAtmosphere from '../hooks/useAtmosphere'
import SendClientSideEvent from '../utils/SendClientSideEvent'

graphql`
  fragment useAcceptRequestToJoinDomainMutation_success on AcceptRequestToJoinDomainSuccess
  @argumentDefinitions(requestId: {type: "ID!"}) {
    viewer {
      ...ReviewRequestToJoinOrgModal_viewer @arguments(requestId: $requestId)
    }
  }
`

const mutation = graphql`
  mutation useAcceptRequestToJoinDomainMutation($requestId: ID!, $teamIds: [ID!]!) {
    acceptRequestToJoinDomain(requestId: $requestId, teamIds: $teamIds) {
      ... on ErrorPayload {
        error {
          message
        }
      }
      ...useAcceptRequestToJoinDomainMutation_success @arguments(requestId: $requestId)
    }
  }
`




const useAcceptRequestToJoinDomainMutation = () => {
  const [commit, submitting] = useMutation(mutation)
  const atmosphere = useAtmosphere()
  const execute = (
    config,
    handlers
  ) => {
    const {variables} = config
    return commit({
      onCompleted: (res) => {
        const error = res.acceptRequestToJoinDomain.error

        if (!error) {
          atmosphere.eventEmitter.emit('addSnackbar', {
            message: '🎉 Success! User added',
            autoDismiss: 5,
            key: 'acceptRequestToJoinDomainSuccess'
          })
          SendClientSideEvent(atmosphere, 'Join Request Reviewed', {
            action: 'accept',
            teamIds: variables.teamIds
          })
          _optionalChain([handlers, 'optionalAccess', _ => _.onSuccess]) && handlers.onSuccess()
        } else {
          atmosphere.eventEmitter.emit('addSnackbar', {
            message: error.message,
            autoDismiss: 5,
            key: 'acceptRequestToJoinDomainError'
          })
          _optionalChain([handlers, 'optionalAccess', _2 => _2.onError]) && handlers.onError()
        }
      },
      // allow components to override default handlers
      ...config
    })
  }
  return [execute, submitting] 
}

export default useAcceptRequestToJoinDomainMutation
